export class Logout {
  type: 'SUCCESS' = 'SUCCESS';

  static path = '/api/authentication/logout';

  static async extract(_response: Response): Promise<Logout> {
    return new Logout();
  }
}
